import { EventEmitter, } from '@angular/core';
var CategoryListComponent = /** @class */ (function () {
    function CategoryListComponent() {
        this.goToCategory = new EventEmitter();
        this.config = {};
    }
    return CategoryListComponent;
}());
export { CategoryListComponent };
